var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-clover"},[_c('div',{staticClass:"container__loader__animation"},[_c('img',{attrs:{"src":require("@/assets/loader.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }